import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add, Download } from "@mui/icons-material";
// import LogoutContainer from "../../Layout/LogoutContainer";
import { HeaderStyle } from "../../Common/styles/header";
import InstrumentsList from "./InstrumentsList";
import { useAppSelector } from "../../../Redux/hooks";
import { platformAdminPermissions } from "../../../utils/roles";
import { dataTablePageShell } from "../../../utils/dataTableShell";

const Instruments = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );

  const handleDownloadSample = () => {
    const link = document.createElement("a");
    link.href = `${import.meta.env.BASE_URL}question_template.csv`;
    link.download = "question_template.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Box sx={HeaderStyle}>
        <Typography variant="h2" color="text.primary">
          Templates
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto", display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              startIcon={<Download />}
              onClick={handleDownloadSample}
            >
              Download Sample CSV
            </Button>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New Template
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, ...dataTablePageShell("calc(100% - 72px)") }}>
        <InstrumentsList showModal={showModal} setShowModal={setShowModal} />
      </Box>
    </>
  );
};

export default Instruments;
